import { IdentificationCard } from "@phosphor-icons/react";
import { CARD, computeExpiryStatus } from "./_shared";

// Iraqi Bar Association card status + renewal CTA. Only rendered for
// lawyer accounts. Colour-coded banner nudges renewal 30 days ahead so
// users don't get locked out mid-week when the card expires.
export default function BarCardSection({ user, renewing, onOpenRenew }) {
  const expiryStatus = computeExpiryStatus(user?.bar_validity_until);
  return (
    <div className={`${CARD} mt-4 p-4`} data-testid="account-bar-card-section">
      {expiryStatus?.level === "expired" && (
        <div className="mb-3 rounded-xl bg-[#FEF2F2] border border-[#F87171] text-[#991B1B] text-[13px] leading-relaxed p-3">
          <b>بِطاقة نِقابتك مُنتَهية الصَّلاحية</b> منذ {Math.abs(expiryStatus.days)} يَوماً
          ({expiryStatus.raw}). قَد تَفقِد بَعض الميّزات — جَدِّدها الآن.
        </div>
      )}
      {expiryStatus?.level === "warn" && (
        <div className="mb-3 rounded-xl bg-[#FFFBEA] border border-[#F0C419] text-[#92400E] text-[13px] leading-relaxed p-3">
          بِطاقة نِقابتك تَنتَهي خِلال <b>{expiryStatus.days} يَوماً</b> ({expiryStatus.raw}).
          يُفَضَّل تَجديدها قَبل انتِهائها.
        </div>
      )}
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/14 flex items-center justify-center flex-shrink-0">
          <IdentificationCard size={22} weight="duotone" className="text-[#B8860B]" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[14px] font-extrabold text-[#0A192F]">بِطاقة نِقابة المحامين</div>
          <div className="text-[12px] text-[#5A6470] mt-0.5">
            {user.bar_validity_until
              ? `صالِحة لِغاية ${user.bar_validity_until}`
              : "لَم تُوَثِّق بِطاقتك بَعد"}
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={onOpenRenew}
        disabled={renewing}
        data-testid="account-renew-bar-card"
        className="mt-3 w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-[#0A192F] hover:bg-[#0F2A4A] text-white text-[13.5px] font-extrabold active:scale-[0.985] transition disabled:opacity-60"
      >
        {renewing ? "جارٍ التَّجديد…" : "تَجديد بِطاقة النِّقابة"}
      </button>
      <p className="text-[11px] text-[#5A6470] mt-2 leading-relaxed">
        مَسح البِطاقة الجَديدة بالذكاء الاصطناعي. رَقَم البِطاقة وَتاريخ التَولّد
        يَجب أَن يُطابِقا حِسابك الحاليّ — لا يُمكِن تَجديد بِطاقة شَخصٍ آخَر.
      </p>
    </div>
  );
}
